import React from "react";
import AdminPage from "../Components/Admin/AdminPage";

function Admin() {
  return (
    <>
      <AdminPage />
    </>
  );
}

export default Admin;
